import { render, staticRenderFns } from "./BlockedFriendsMobile.vue?vue&type=template&id=22a444fd&scoped=true"
import script from "./BlockedFriendsMobile.vue?vue&type=script&lang=js"
export * from "./BlockedFriendsMobile.vue?vue&type=script&lang=js"
import style0 from "./BlockedFriendsMobile.vue?vue&type=style&index=0&id=22a444fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a444fd",
  null
  
)

export default component.exports